export default {
    "_fuels":[{
        id: 1,
        name: "Metano",
        slug: "metano",
        enabled: true
    },{
        id: 8,
        name: "Metano Self",
        slug: "metano_self",
        enabled: false
    },{
        id: 2,
        name: "Idrogeno",
        slug: "idrogeno",
        enabled: false
    },{
        id: 3,
        name: "Bioetanolo",
        slug: "bioetanolo",
        enabled: false
    },{
        id: 4,
        name: "GPL",
        slug: "gpl",
        enabled: true
    },{
        id: 5,
        name: "Colonnine Elettriche",
        slug: "colonnine_elettriche",
        enabled: true
    },{
        id: 7,
        name: "LNG",
        slug: "lng",
        enabled: true
    }],
    getById(_id) {
        var result = this._fuels.find(obj => {
            return obj.id === _id
        });

        return result;
    },
    getByName(_name) {
        var result = this._fuels.find(obj => {
            return obj.name.toLowerCase() === _name.toLowerCase()
        });

        return result;
    },
    getBySlug(_slug) {
        var result = this._fuels.find(obj => {
            return obj.slug.toLowerCase() === _slug.toLowerCase()
        });

        return result;
    },
    getList() {
        var results = this._fuels.filter(obj => {
            return obj.enabled === true
        })

        return results;
    }
}
